import rest from '@modules/rest'
import upload from '@modules/upload'
import * as middlewareGet from '@graphql/middleware/queries'
import middleware from '@graphql/middleware'
import { getUploadEndpoint, getFileUrl } from '@modules/fileHelpers'
import {
  mapBankAccount,
  mapBankAccountInput,
} from '@convenia/common-organisms/SystemFields/content/mappers/bankAccount'

export async function getOptions () {
  const [ err, data ] = await middleware(middlewareGet.GetBankAccountOptions)

  const mapOption = option => ({ ...option, id: +option.id })
  const options = {
    bankAccount: {
      bankList: (data.bankList || []).map(mapOption),
      bankAccountTypes: (data.bankAccountTypes || []).map(mapOption),
      modality: data.modality
    }
  }

  return [ err, options ]
}

export const getBankAccount = async (params) => {
  try {
    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/bank-accounts/employee`
    const { data = [] } = await rest.get(url)

    const bankAccounts = data.map(bankAccount =>
      mapBankAccount(bankAccount, { employeeId, getFileUrl })
    )

    return [ null, bankAccounts ]
  } catch (err) {
    return [ err, null ]
  }
}

export const createBankAccount = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/bank-accounts/employee`
    const body = mapBankAccountInput({ data, schema })

    const response = await rest.post(url, { body, headers: { bcv: true } })

    const bankAccount = mapBankAccount(response?.data, { employeeId, getFileUrl })

    return [ null, bankAccount ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateBankAccount = async (data, params) => {
  try {
    const bankAccountId = data?.id
    const { employeeId, companyId, schema } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/bank-accounts/${bankAccountId}/employee`
    const body = mapBankAccountInput({ data, schema })

    await rest.put(url, { body, headers: { bcv: true } })

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}

export const deleteBankAccount = async (data, params) => {
  try {
    const bankAccountId = data?.id

    if (typeof bankAccountId !== 'string')
      return [ null, null ]

    const { employeeId, companyId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/bank-accounts/${bankAccountId}/employee`

    await rest.delete(url)

    return [ null, null ]
  } catch (err) {
    return [ err, null ]
  }
}

export const uploadBankAccountFiles = async ({ id, files, employeeId }) => {
  try {
    const endpoint = getUploadEndpoint(employeeId, id, 'bank_account')

    const data = await upload({ files, endpoint })

    return [ null, data || [] ]
  } catch (err) {
    return [ err, null ]
  }
}
